import { createAction } from "@reduxjs/toolkit"

export const getUserTypeListAction = createAction("getUserTypeListAction")

export const getFrontlineUsersListAction = createAction("getFrontlineUsersListAction")
export const exportFrontlineUsersAction = createAction("exportFrontlineUsersAction")

export const uploadFrontlineUserAction = createAction("uploadFrontlineUserAction")
export const getFrontlineUsersDataAction = createAction("getFrontlineUsersDataAction")
export const deleteUserAction = createAction("deleteUserAction")
export const EditFrontlineUsersDataAction = createAction("EditFrontlineUsersDataAction")

export const updateUserStatusAction = createAction("updateUserStatusAction")
export const uploadFrontlineBulkUserAction = createAction("uploadFrontlineBulkUserAction")
export const getAdminUsersListAction = createAction("getAdminUsersListAction")

export const uploadAdminUserAction = createAction("uploadAdminUserAction")

export const getUserMainListAction = createAction("getUserMainListAction")
export const getRoleUsersListAction = createAction("getRoleUsersListAction")
export const getNewRestaurantListAction = createAction("getNewRestaurantListAction")

export const getAdminUsersDataAction = createAction("getAdminUsersDataAction")
export const EditAdminUsersDataAction = createAction("EditAdminUsersDataAction")

export const updateAdminUserStatusAction = createAction("updateAdminUserStatusAction")
export const uploadFrontlineBulkUserAdminAction = createAction("uploadFrontlineBulkUserAdminAction")

export const getDashboardStatsAction = createAction("getDashboardStatsAction")

export const revertAllSuperAdmin = createAction("revertAllSuperAdmin")

export const getVersionListAction = createAction("getVersionListAction")

export const addVersionAction = createAction("addVersionAction")
export const getVersionDataAction = createAction("getVersionDataAction")
export const updateVersionAction = createAction("updateVersionAction")
export const deleteVersionAction = createAction("deleteVersionAction")
export const addNotificationAction = createAction("addNotificationAction")
export const getNotificationListAction = createAction("getNotificationList")
export const deleteNotificationAction = createAction("deleteNotification")
export const sendNotificationAction = createAction("sendNotification")
export const getNotificationsAction = createAction("getNotifications")
export const EditNotificationAction = createAction("EditNotificationAction")
export const uploadNotificationImageAction = createAction("uploadNotificationImageAction")
export const addGiftCardAction = createAction("addGiftCardAction")
export const getGiftCardListAction = createAction("getGiftCardList")
export const deleteGiftCardAction = createAction("deleteGiftCard")
export const getGiftCardsAction = createAction("getGiftCard")
export const EditGiftCardAction = createAction("EditGiftCardAction")
export const uploadGiftCardImageAction = createAction("uploadGiftCardImageAction")
export const getGamificationDataAction = createAction("getGamificationDataAction")
export const EditGamificationAction = createAction("EditGamificationAction")
export const getEventDataAction = createAction("getEventDataAction")
export const addEventAction = createAction("addEventAction")
export const deleteEventAction = createAction("deleteEventAction")
export const getEventDetailsAction = createAction("getEventDetailsAction")
export const editEventAction = createAction("editEventAction")
export const addMenuImageAction = createAction("addMenuImageAction")
export const getMenuImageAction = createAction("getMenuImageAction")
export const uploadMenuImageAction = createAction("uploadMenuImageAction")
export const downloadMenuTemplateAction = createAction("downloadMenuTemplateAction")
export const getDynamicMenuFieldsAction = createAction("getDynamicMenuFieldsAction")
export const deleteMenuFieldAction = createAction("deleteMenuFieldAction")
export const createDynamicMenuFieldsAction = createAction("createDynamicMenuFieldsAction")
export const editDynamicMenuFieldsAction = createAction("editDynamicMenuFieldsAction")
export const sendInviteAction = createAction("sendInviteAction")
export const getUserRoleAction = createAction("getUserRoleAction")
export const getRoleDetailsAction = createAction("getRoleDetailsAction")
export const editRoleDetailsAction = createAction("editRoleDetailsAction")
export const addRoleDetailsAction = createAction("addRoleDetailsAction")
export const deleteRoleDetailsAction = createAction("deleteRoleDetailsAction")
export const addMenuCategoryAction = createAction("addMenuCategoryAction")
export const changeMenuOrderAction = createAction("changeMenuOrderAction")
export const getMenuCategoryDetailsAction = createAction("getMenuCategoryDetailsAction")
export const editMenuCategoryDetailsAction = createAction("editMenuCategoryDetailsAction")
export const deleteMenuCategoryAction = createAction("deleteMenuCategoryAction")
export const getRecommendationCategoryListAction = createAction(
  "getRecommendationCategoryListAction"
)
export const getRecommendedCategoryDetailsAction = createAction(
  "getRecommendedCategoryDetailsAction"
)
export const updateRecommendationCategoryDetailsAction = createAction(
  "updateRecommendationCategoryDetailsAction"
)
export const getHeaderNotificationAction = createAction("getHeaderNotificationAction")
export const createHeaderNotificationAction = createAction("createHeaderNotificationAction")
export const getTilesListAction = createAction("getTilesListAction")
export const createTileAction = createAction("createTileAction")
export const updateTileAction = createAction("updateTileAction")
export const deleteTileAction = createAction("deleteTileAction")
export const reorderTilesAction = createAction("reorderTilesAction")
export const getTileDetailsAction = createAction("getTileDetailsAction")
export const enableDisableTilesAction = createAction("enableDisableTilesAction")
export const getWeeklyCategoryAction = createAction("getWeeklyCategoryAction")
export const uploadWeeklyCategoryImageAction = createAction("uploadWeeklyCategoryImageAction")
export const addWeeklyCategoryImageAction = createAction("addWeeklyCategoryImageAction")
export const addWeeklyCategoryAction = createAction("addWeeklyCategoryAction")
export const editWeeklyCategoryAction = createAction("editWeeklyCategoryAction")
export const getAdvertisementsAction = createAction("getAdvertisementsAction")
export const getAdvertisementDetailsAction = createAction("getAdvertisementDetailsAction")
export const addAdvertisementsAction = createAction("addAdvertisementsAction")
export const updateAdvertisementsAction = createAction("updateAdvertisementsAction")
export const deleteAdvertisementsAction = createAction("deleteAdvertisementsAction")
export const uploadPrivacyPolicyDocumentAction = createAction("uploadPrivacyPolicyDocumentAction")
export const getPrivacyPolicyAction = createAction("getPrivacyPolicyAction")
export const getNotableVipsAction = createAction("getNotableVipsAction")
export const getNotableUsersAction = createAction("getNotableUsersAction")
export const updateNotableUsersAction = createAction("updateNotableUsersAction")
export const getVipDetailsAction = createAction("getVipDetailsAction")
export const approveVipAction = createAction("approveVipAction")
export const secondApproveVipAction = createAction("secondApproveVipAction")
export const uploadVipImageAction = createAction("uploadVipImageAction")
export const createNotableVipAction = createAction("createNotableVipAction")
export const updateNotableVipAction = createAction("updateNotableVipAction")
export const getNotableVipGroupsAction = createAction("getNotableVipGroupsAction")
export const createNotableVipGroupAction = createAction("createNotableVipGroupAction")
export const updateNotableVipGroupAction = createAction("updateNotableVipGroupAction")
export const deleteNotableVipGroupAction = createAction("deleteNotableVipGroupAction")
export const getVipGroupDynamicFieldsAction = createAction("getVipGroupDynamicFieldsAction")
export const createVipGroupSectionAction = createAction("createVipGroupSectionAction")
export const updateVipGroupSectionAction = createAction("updateVipGroupSectionAction")
export const deleteVipGroupSectionAction = createAction("deleteVipGroupSectionAction")
export const createVipGroupFieldAction = createAction("createVipGroupFieldAction")
export const updateVipGroupFieldAction = createAction("updateVipGroupFieldAction")
export const deleteVipGroupFieldAction = createAction("deleteVipGroupFieldAction")
export const reorderVipGroupSectionsAction = createAction("reorderVipGroupSectionsAction")
export const getNotableGroupTypesAction = createAction("getNotableGroupTypesAction")
export const getAvataarPromptAction = createAction("getAvataarPromptAction")
export const updateAvataarPromptAction = createAction("updateAvataarPromptAction")
export const getVipGroupFieldsAction = createAction("getVipGroupFieldsAction")
export const deleteNotableVipAction = createAction("deleteNotableVipAction")
export const getTiersAction = createAction("getTiersAction")
export const createTierAction = createAction("createTierAction")
export const updateTierAction = createAction("updateTierAction")
export const deleteTierAction = createAction("deleteTierAction")
export const updateTierOrderAction = createAction("updateTierOrderAction")
export const getCategoriesAction = createAction("getCategoriesAction")
export const createCategoryAction = createAction("createCategoryAction")
export const updateCategoryAction = createAction("updateCategoryAction")
export const deleteCategoryAction = createAction("deleteCategoryAction")
export const getCardTypesAction = createAction("getCardTypesAction")
export const getRewardsAction = createAction("getRewardsAction")
export const createRewardAction = createAction("createRewardAction")
export const updateRewardAction = createAction("updateRewardAction")
export const deleteRewardAction = createAction("deleteRewardAction")
export const reorderRewardsAction = createAction("reorderRewardsAction")
export const setRewardSpreeQuantityAction = createAction("setRewardSpreeQuantityAction")
export const getSpreeWindowQuantitiesAction = createAction("getSpreeWindowQuantitiesAction")
export const uploadGiftCardCouponsAction = createAction("uploadGiftCardCouponsAction")
export const getGiftCardRedemptionsAction = createAction("getGiftCardRedemptionsAction")
export const getAllRedemptionsAction = createAction("getAllRedemptionsAction")
export const changeRedemptionStatusAction = createAction("changeRedemptionStatusAction")
export const getRewardStateAction = createAction("getRewardStateAction")
export const updateRewardStateAction = createAction("updateRewardStateAction")
export const getAnalyticsSummaryAction = createAction("getAnalyticsSummaryAction")
export const exportAnalyticsAction = createAction("exportAnalyticsAction")
export const uploadRewardImageAction = createAction("uploadRewardImageAction")
export const getSectionTypesAction = createAction("getSectionTypesAction")
export const createSectionTypeAction = createAction("createSectionTypeAction")
export const getSectionTypeDetailAction = createAction("getSectionTypeDetailAction")
export const updateSectionTypeAction = createAction("updateSectionTypeAction")
export const deleteSectionTypeAction = createAction("deleteSectionTypeAction")
export const createSectionFieldAction = createAction("createSectionFieldAction")
export const updateSectionFieldAction = createAction("updateSectionFieldAction")
export const deleteSectionFieldAction = createAction("deleteSectionFieldAction")
export const reorderSectionTypesAction = createAction("reorderSectionTypesAction")
export const reorderSectionFieldsAction = createAction("reorderSectionFieldsAction")
export const getPreshiftsAction = createAction("getPreshiftsAction")
export const createPreshiftAction = createAction("createPreshiftAction")
export const getPreshiftDetailAction = createAction("getPreshiftDetailAction")
export const updatePreshiftAction = createAction("updatePreshiftAction")
export const deletePreshiftAction = createAction("deletePreshiftAction")
export const publishPreshiftAction = createAction("publishPreshiftAction")
export const unpublishPreshiftAction = createAction("unpublishPreshiftAction")
export const updatePreshiftSectionDataAction = createAction("updatePreshiftSectionDataAction")
export const updateAllPreshiftSectionsAction = createAction("updateAllPreshiftSectionsAction")
export const addItemsToSectionAction = createAction("addItemsToSectionAction")
export const removeItemFromSectionAction = createAction("removeItemFromSectionAction")
export const uploadPreshiftMediaAction = createAction("uploadPreshiftMediaAction")
export const reorderPreshiftSectionsAction = createAction("reorderPreshiftSectionsAction")
export const copyPreshiftAction = createAction("copyPreshiftAction")
export const getCMSRestaurantListAction = createAction("getCMSRestaurantListAction")
export const getCMSRestaurantDetailAction = createAction("getCMSRestaurantDetailAction")
export const createCMSRestaurantAction = createAction("createCMSRestaurantAction")
export const updateCMSRestaurantAction = createAction("updateCMSRestaurantAction")
export const getCMSRestaurantGroupListAction = createAction("getCMSRestaurantGroupListAction")
export const getCMSRestaurantGroupDetailAction = createAction("getCMSRestaurantGroupDetailAction")
export const createCMSRestaurantGroupAction = createAction("createCMSRestaurantGroupAction")
export const updateCMSRestaurantGroupAction = createAction("updateCMSRestaurantGroupAction")
export const getCMSUsersForAssignmentAction = createAction("getCMSUsersForAssignmentAction")
export const uploadCMSMediaAction = createAction("uploadCMSMediaAction")
export const reorderCMSRestaurantsAction = createAction("reorderCMSRestaurantsAction")
export const getRaffleWinnersAction = createAction("getRaffleWinnersAction")
export const updateRaffleWinnerPrizeClaimedAction = createAction(
  "updateRaffleWinnerPrizeClaimedAction"
)
export const getVipCategoriesAction = createAction("getVipCategoriesAction")
export const getRewardsPermissionsAction = createAction("getRewardsPermissionsAction")
export const updateRewardsPermissionsAction = createAction("updateRewardsPermissionsAction")

export const getShoppingSpreeWindowsAction = createAction("getShoppingSpreeWindowsAction")
export const createShoppingSpreeWindowAction = createAction("createShoppingSpreeWindowAction")
export const updateShoppingSpreeWindowAction = createAction("updateShoppingSpreeWindowAction")
export const deleteShoppingSpreeWindowAction = createAction("deleteShoppingSpreeWindowAction")
